<ng-http-loader
  [backdrop]="false"
  [debounceDelay]="400"
  [filteredUrlPatterns]="['KeepAlive']"
  [entryComponent]="loadSpinner"
></ng-http-loader>

@if (showBookingLayout && initialDataLoaded) {
  <app-header></app-header>
}

@if (cookiesSupported) {
  <router-outlet></router-outlet>
}

<!-- Safari doesn't support Cookies in iFrame, then we show a link to open 2reserve in a new window -->
@if (!cookiesSupported && initialDataLoaded) {
  <div class="no-cookie-support">
    <a mat-stroked-button target="_blank" [routerLink]="[catalog!.name]">{{ 'IFRAME_WITHOUT_COOKIE_SUPPORT' | translate }}</a>
  </div>
}

@if (initialDataLoadError) {
  <div class="app-loading">
    @if (initialDataLoadError === 'OrderNotFound') {
      <mat-error translate="ERROR.ORDER_NOT_FOUND"></mat-error>
    }
  </div>
}

@if (showBookingLayout && showFooter && initialDataLoaded) {
  <app-footer></app-footer>
}
